var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "course-review"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col pb-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('course.students_review_about_course')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 pt-2"
  }, [_c('div', {
    staticClass: "star-wrapper"
  }, [_c('div', {
    staticClass: "rating-ptag"
  }, [_c('span', {
    staticClass: "library-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('course.ratings')) + "\n    "), (parseInt(_vm.$store.getters.getCurrentCourse.rating) == 0) ? _c('span', [_c('star-rating', {
    attrs: {
      "rating": parseInt(_vm.$store.getters.getCurrentCourse.rating),
      "read-only": true,
      "increment": 0.5,
      "max-rating": 5,
      "inactive-color": "#96999a",
      "active-color": "#ffc000",
      "star-size": 15
    }
  })], 1) : _c('span', [_c('star-rating', {
    attrs: {
      "rating": parseInt(_vm.$store.getters.getCurrentCourse.rating.toFixed(1)),
      "read-only": true,
      "increment": 0.5,
      "max-rating": 5,
      "inactive-color": "#96999a",
      "active-color": "#ffc000",
      "star-size": 15
    }
  })], 1)])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-8"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-swiper"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOptionReview
    }
  }, _vm._l((10), function(n) {
    return _c('swiper-slide', {
      key: n
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-11 offset-md-1"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "row align-items-center"
    }, [_c('div', {
      staticClass: "col-auto"
    }, [_c('div', {
      staticClass: "user-img"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/user.png",
        "width": "100",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 user-name"
    }, [_c('span', [_vm._v(" Student Name")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("12 days to go")])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "rating-star"
    }, [_c('i', {
      staticClass: "mdi mdi-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "mdi mdi-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "mdi mdi-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "mdi mdi-star",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "mdi mdi-star-half-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 description pt-3"
    }, [_vm._v("\n                                    I absolutely loved it - it was about building blocks and I learned a lot quickly. I also liked how we started simple and built on it."), _c('br'), _vm._v("\n                                    I did not find the tic-tac and cards assignments that useful - more data oriented assignments could def. be more useful. In general - awesome.\n                                  ")])])])])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "options": _vm.swiperOptionReview
    }
  }, [_c('div', {
    staticClass: "swiper-button-prev swiper-review-prev",
    slot: "button-prev"
  }, [_c('i', {
    staticClass: "mdi mdi-chevron-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-review-next",
    slot: "button-next"
  }, [_c('i', {
    staticClass: "mdi mdi-chevron-right"
  })])])], 1)])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "histo"
  }, [_c('div', {
    staticClass: "histo-rate"
  }, [_c('span', {
    staticClass: "histo-star"
  }, [_vm._v("\n                      5     ")]), _vm._v(" "), _c('span', {
    staticClass: "bar-block"
  }, [_c('span', {
    staticClass: "bar",
    attrs: {
      "id": "bar-five"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "four histo-rate"
  }, [_c('span', {
    staticClass: "histo-star"
  }, [_vm._v("\n                      4           ")]), _vm._v(" "), _c('span', {
    staticClass: "bar-block"
  }, [_c('span', {
    staticClass: "bar",
    attrs: {
      "id": "bar-four"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "three histo-rate"
  }, [_c('span', {
    staticClass: "histo-star"
  }, [_vm._v("\n                      3           ")]), _vm._v(" "), _c('span', {
    staticClass: "bar-block"
  }, [_c('span', {
    staticClass: "bar",
    attrs: {
      "id": "bar-three"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "two histo-rate"
  }, [_c('span', {
    staticClass: "histo-star"
  }, [_vm._v("\n                      2           ")]), _vm._v(" "), _c('span', {
    staticClass: "bar-block"
  }, [_c('span', {
    staticClass: "bar",
    attrs: {
      "id": "bar-two"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "one histo-rate"
  }, [_c('span', {
    staticClass: "histo-star"
  }, [_vm._v("\n                      1           ")]), _vm._v(" "), _c('span', {
    staticClass: "bar-block"
  }, [_c('span', {
    staticClass: "bar",
    attrs: {
      "id": "bar-one"
    }
  })])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54d01d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/courseReview.vue
// module id = RO7/
// module chunks = 1